import React from 'react';
import { Leaf, Wrench, Scissors, Package, Layers, Users } from 'lucide-react';

interface Tab {
  id: string;
  label: string;
  icon: React.ReactNode;
}

interface PlantDetailTabsProps {
  activeTab: string;
  onTabChange: (tabId: string) => void;
}

export default function PlantDetailTabs({ activeTab, onTabChange }: PlantDetailTabsProps) {
  const tabs: Tab[] = [
    { id: 'sowing', label: 'Planting', icon: <Leaf className="h-4 w-4" /> },
    { id: 'companions', label: 'Companions', icon: <Users className="h-4 w-4" /> },
    { id: 'varieties', label: 'Varieties', icon: <Layers className="h-4 w-4" /> },
    { id: 'maintenance', label: 'Care', icon: <Wrench className="h-4 w-4" /> },
    { id: 'harvesting', label: 'Harvest', icon: <Scissors className="h-4 w-4" /> },
    { id: 'storage', label: 'Storage', icon: <Package className="h-4 w-4" /> },
  ];

  return (
    <nav className="bg-white border-b sticky top-0 z-10">
      <div className="container mx-auto px-4">
        <div className="flex">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`flex items-center gap-1.5 px-4 py-3 text-sm border-b-2 transition-colors ${
                activeTab === tab.id
                  ? 'border-primary-500 text-primary-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700'
              }`}
            >
              {tab.icon}
              <span>{tab.label}</span>
            </button>
          ))}
        </div>
      </div>
    </nav>
  );
}